import { MappedClass, MappedProperty, MappedPropertyCurrency, MappedPropertyDate } from '@h5s/util-object';
import Big from 'big.js';
import { DateTime } from 'luxon';
import { QueryResource } from './query-resource';

@MappedClass()
export class QueryPacket extends QueryResource {
  @MappedProperty()
  allInclusive?: boolean;

  @MappedProperty()
  applicateAllStay?: boolean;

  @MappedPropertyDate()
  beginSellLower?: DateTime;

  @MappedPropertyDate()
  beginSellUpper?: DateTime;

  @MappedPropertyDate()
  beginValidityLower?: DateTime;

  @MappedPropertyDate()
  beginValidityUpper?: DateTime;

  @MappedProperty()
  breakfast?: boolean;

  @MappedProperty()
  cancellationPolicyId?: number;

  @MappedProperty()
  checkInMonday?: boolean;

  @MappedProperty()
  checkInTuesday?: boolean;

  @MappedProperty()
  checkInWednesday?: boolean;

  @MappedProperty()
  checkInThursday?: boolean;

  @MappedProperty()
  checkInFriday?: boolean;

  @MappedProperty()
  checkInSaturday?: boolean;

  @MappedProperty()
  checkInSunday?: boolean;

  @MappedProperty()
  checkOutMonday?: boolean;

  @MappedProperty()
  checkOutTuesday?: boolean;

  @MappedProperty()
  checkOutWednesday?: boolean;

  @MappedProperty()
  checkOutThursday?: boolean;

  @MappedProperty()
  checkOutFriday?: boolean;

  @MappedProperty()
  checkOutSaturday?: boolean;

  @MappedProperty()
  checkOutSunday?: boolean;

  @MappedProperty()
  dinner?: boolean;

  @MappedProperty()
  discountDecimalsRounding?: number;

  @MappedPropertyCurrency()
  discountLower?: Big;

  @MappedPropertyCurrency()
  discountUpper?: Big;

  @MappedProperty()
  earlyBird?: number;

  @MappedPropertyDate()
  endSellLower?: DateTime;

  @MappedPropertyDate()
  endSellUpper?: DateTime;

  @MappedPropertyDate()
  endValidityLower?: DateTime;

  @MappedPropertyDate()
  endValidityUpper?: DateTime;

  @MappedProperty()
  extraParameters?: boolean;

  @MappedProperty()
  lastMinute?: number;

  @MappedProperty()
  lunch?: boolean;

  @MappedProperty()
  minimumStay?: number;

  @MappedProperty()
  numberOfNights?: number;

  @MappedProperty()
  offerId?: number;

  @MappedProperty()
  promoCode?: string;

  @MappedProperty()
  stayId?: number;

  @MappedProperty()
  webAvailable?: boolean;

  @MappedProperty()
  webOrder?: number;

  @MappedPropertyCurrency()
  weekendExtraLower?: Big;

  @MappedPropertyCurrency()
  weekendExtraUpper?: Big;

  constructor(fields: Partial<QueryPacket>) {
    super(fields);
    Object.assign(this, fields);
  }
}
